import {
  Paper,
  Text,
  Container,
  Button,
  Center,
  Radio,
  Stack
} from '@mantine/core';
import { useDocumentTitle } from '@mantine/hooks';
import bigLogo from '../../img/big-new-logo.png';
import { useEffect, useState } from 'react';
import { visiMemberData } from '../../GeneralFunction';
import { useNavigate } from "react-router-dom";
import { visiUserSession } from '../../GeneralFunction';
import { notifications } from '@mantine/notifications';
import {
  IconX
} from "@tabler/icons-react";
import { useAuth } from '../../AuthContext';
import LoginLogoutApi from "../../api/LoginLogoutApi";

export const SelectMember = () => {

  useDocumentTitle("Visiopt - Select Member");

  const navigate = useNavigate();
  const { userRolePermissions } = useAuth();

  useEffect(() => {
    if(visiUserSession() && visiUserSession().page){
      navigate(visiUserSession().page);
    }
  }, [navigate]);

  const handleSelectMemberFormSubmit = (event:any) => {
    event.preventDefault();
    try {
      let localMemberData = visiMemberData();
      LoginLogoutApi.login({
        email : localMemberData.member_email,
        select_member : selectedMemberId,
        remember_me : localMemberData.remember_me,
        select_member_token : localMemberData.select_member_token,
      })
      .then(SelectMemberSubmitAPIResult => SelectMemberSubmitAPIResult.text())
      .then(SelectMemberSubmitAPIResult => {
        const SelectMemberSubmitAPIResultJSON = JSON.parse(SelectMemberSubmitAPIResult);
        if(SelectMemberSubmitAPIResultJSON.status === 1){
          localStorage.setItem("visiUserData",  btoa(JSON.stringify(SelectMemberSubmitAPIResultJSON.data)));
          localStorage.removeItem('visiMemberData');
          var member_user_permission = SelectMemberSubmitAPIResultJSON.data.access_permission;
          let userPermissions = [];
          if(member_user_permission){
            for(const role in member_user_permission){
              userPermissions = member_user_permission[role];
            }
          }
          userRolePermissions(userPermissions);

          // an MCP connect flow was waiting for this login
          const mcpRequestId = sessionStorage.getItem('mcpRequestId');
          if (mcpRequestId) {
            navigate("/mcp-connect?request_id="+mcpRequestId);
            return;
          }

          if(visiUserSession() && visiUserSession().page){
            navigate(visiUserSession().page);
          }else{
            navigate("/dashboard");
          }
        }else{
          notifications.show({
            color: 'red',
            icon: <IconX size="1.1rem" />,
            title: 'Error',
            message: SelectMemberSubmitAPIResultJSON.message,
          })
        }
      })
      .catch(error => console.log('error', error));
    } catch (error) {
      console.log('error', error)
    }
  };

  const [MemberData, setMemberData] = useState<Member[]>([]);
  const [selectedMemberId, setSelectedMemberId] = useState('');

  type Member = {
    member_id: string;
    member_email: string;
  }

  useEffect(() => {
    let localMemberData = visiMemberData();
    if(localMemberData){
      try {
        LoginLogoutApi.getmemberlist({
          email : localMemberData.member_email
        })
        .then(APIResponse => APIResponse.text())
        .then(APIResult => {
          const APIResultJSON = JSON.parse(APIResult);
          if(APIResultJSON.status === 1){
            if(APIResultJSON.data){
              setMemberData(APIResultJSON.data);
              if(APIResultJSON.data.length > 0){
                setSelectedMemberId(APIResultJSON.data[0].member_id);
              }
            }
          }else{
            notifications.show({
              color: 'red',
              icon: <IconX size="1.1rem" />,
              title: 'Error',
              message: APIResultJSON.message,
            })
          }
        })
        .catch(error => console.log('error', error));
      } catch (error) {
        console.log('error', error)
      }
    }else{
      navigate("/login");
    }
  }, [navigate]);

  return (
    <Container size={800} my={40}>
      <Paper p={30} mt={30} radius="8px" style={{ border : '1px solid #dee2e6' }}>
        <Paper w="50%" mx="auto">
          <Center>
            <img src={bigLogo} alt="Company Logo"/>
          </Center>
          <Center>
            <Text>You have to choose account for login</Text>
          </Center>
          <form onSubmit={handleSelectMemberFormSubmit}>
            <Center>
              <Stack my={15}>
                {MemberData.map((item,index) => (
                  <Radio label={item.member_email}
                    name="select_member"
                    value={item.member_id}
                    onChange={(event) => {
                      setSelectedMemberId(item.member_id);
                    }}
                    checked={selectedMemberId === item.member_id}
                  />
                ))}
              </Stack>
            </Center>
            <Button fullWidth mt="xl" type="submit">
              Continue
            </Button>
          </form>
        </Paper>
      </Paper>
        <p style={{ textAlign : 'center' }}>By Using This Site You Understand & Agree To Our <b><a href="https://visiopt.com/terms-of-use.html" target="_blank" rel="noreferrer" style={{color:"black",textDecoration:"none"}}>Terms Of Service </a></b>& <b><a href="https://visiopt.com/privacy-policy.html" target="_blank" rel="noreferrer" style={{color:"black",textDecoration:"none"}}>Privacy Policy</a></b>.</p>
    </Container>
  );
}